import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-0 bg-[#FAFAF8]" data-id="element-67"></section>;
}